import { oneErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { postContextFeedbackApiUrlSelector } from '../selectors/contextApiSelectors';
import { getPayloadForContextFeedbackLoop } from '../utils/recentSearchPayloadUtils';
import {
  FLIGHT_KEY, HOTEL_KEY,
  RECENT_SEARCH_FEEDBACK_AIR,
  RECENT_SEARCH_FEEDBACK_HOTEL,
} from '../constants/categoryConstants';
import { CLIENT_ID } from '../constants/apiConstants';
import { generateUUID } from '../utils/generateUuidUtils';
import { moduleName } from '../constants';

export const generateHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  clientId: CLIENT_ID,
  correlation_id: generateUUID(),
});

export const postContextFeedbackThunk = ({
  eventType,
  suggestionIndex,
  recentSearchData,
  lob,
  trackingId,
} = {}) => (dispatch, getState) => {
  const state = getState();
  const postContextFeedbackUrl = postContextFeedbackApiUrlSelector(state);
  let intentCode;

  if (lob === FLIGHT_KEY) {
    intentCode = RECENT_SEARCH_FEEDBACK_AIR;
  } else if (lob === HOTEL_KEY) {
    intentCode = RECENT_SEARCH_FEEDBACK_HOTEL;
  }

  const payload = getPayloadForContextFeedbackLoop({
    recentSearchData,
    eventType,
    intentCode,
    lob,
    suggestionIndex,
    trackingId,
  });

  const reporting = { moduleId: moduleName, componentName: 'postContextFeedback' };
  dispatch(oneErrorOnNotOkFetchye(postContextFeedbackUrl, {
    method: 'POST',
    credentials: 'include',
    headers: generateHeaders(),
    body: JSON.stringify(payload),
  }, { reporting }));
};
